import axios from 'axios';
import { SERVER } from '../config/config';

class Analytics {
  constructor() {
    this.sessionId = this.getOrCreateSessionId();
    this.currentPage = null;
    this.pageStartTime = null;
    this.initialized = false;
  }

  getOrCreateSessionId() {
    let sessionId = sessionStorage.getItem('analytics_session_id');
    if (!sessionId) {
      sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      sessionStorage.setItem('analytics_session_id', sessionId);
    }
    return sessionId;
  }

  getTrafficSource() {
    const referrer = document.referrer;
    const urlParams = new URLSearchParams(window.location.search);
    
    const utmSource = urlParams.get('utm_source');
    const utmMedium = urlParams.get('utm_medium');
    const utmCampaign = urlParams.get('utm_campaign');

    let trafficSource = 'Direct';
    
    if (utmSource) {
      trafficSource = utmSource;
    } else if (referrer) {
      if (referrer.includes('google')) trafficSource = 'Google';
      else if (referrer.includes('facebook')) trafficSource = 'Facebook';
      else if (referrer.includes('instagram')) trafficSource = 'Instagram';
      else if (referrer.includes('tiktok')) trafficSource = 'TikTok';
      else if (referrer.includes('twitter') || referrer.includes('t.co')) trafficSource = 'Twitter';
      else if (referrer.includes('linkedin')) trafficSource = 'LinkedIn';
      else trafficSource = 'Referral';
    }

    return {
      referrer,
      trafficSource,
      utmSource,
      utmMedium,
      utmCampaign
    };
  }

  async init() {
    if (this.initialized) return;
    
    try {
      const trafficData = this.getTrafficSource();
      await axios.post(`${SERVER}/analytics/session`, {
        sessionId: this.sessionId,
        userAgent: navigator.userAgent,
        ...trafficData
      });
      this.initialized = true;
    } catch (error) {
      console.error('Analytics init error:', error);
    }
  }

  getPageTitle(path) {
    // Map paths to friendly names
    const pageTitles = {
      '/': 'Home',
      '/admin/login': 'Admin Login',
      '/admin/dashboard': 'Admin Dashboard',
      // Not implemented yet 
      // '/about': 'About Us',          
      // '/contact': 'Contact',           
      // '/services': 'Our Services',
    };
    
    // Return mapped title or path (don't use document.title as it's the website title)
    return pageTitles[path] || path;
  }

  async trackPageView(pagePath, pageTitle) {
    // Send previous page time if exists
    if (this.currentPage && this.pageStartTime) {
      const timeSpent = Math.floor((Date.now() - this.pageStartTime) / 1000);
      const title = this.getPageTitle(this.currentPage);
      try {
        await axios.post(`${SERVER}/analytics/pageview`, {
          sessionId: this.sessionId,
          pagePath: this.currentPage,
          pageTitle: title,
          timeSpent
        });
      } catch (error) {
        console.error('Error tracking page view:', error);
      }
    }

    // Start tracking new page
    this.currentPage = pagePath || window.location.pathname;
    this.pageStartTime = Date.now();
  }

  async trackEvent(eventType, eventData = {}) {
    try {
      await axios.post(`${SERVER}/analytics/event`, {
        sessionId: this.sessionId,
        eventType,
        eventData
      });
    } catch (error) {
      console.error('Error tracking event:', error);
    }
  }

  // Track when user leaves the page
  setupBeforeUnload() {
    window.addEventListener('beforeunload', () => {
      if (this.currentPage && this.pageStartTime) {
        const timeSpent = Math.floor((Date.now() - this.pageStartTime) / 1000);
        const title = this.getPageTitle(this.currentPage);
        // Use sendBeacon for reliable tracking on page unload
        const data = JSON.stringify({
          sessionId: this.sessionId,
          pagePath: this.currentPage,
          pageTitle: title,
          timeSpent
        });
        navigator.sendBeacon(`${SERVER}/analytics/pageview`, data);
      }
    });
  }
}

export const analytics = new Analytics();
